(async () => {
    const { Core } = await importModule('Core');
    const EL_PARENT = '[data-cart-item]';
    const CN_LOADING = '!loading';
    const ATTR_VARIANT_ID = 'variant-id';
    const ATTR_SELLING_PLAN_ID = 'selling-plan-id';
    const ATTR_LINE_KEY = 'line';
    const ATTR_ITEM_KEY = 'key';

    class CartControl extends Core {
        get variantId() {
            return this.getAttribute(ATTR_VARIANT_ID);
        }

        get sellingPlanId() {
            return this.getAttribute(ATTR_SELLING_PLAN_ID) || '';
        }

        get $parentItem() {
            return this.closest(EL_PARENT);
        }

        get line() {
            return this.getAttribute(ATTR_LINE_KEY)
        }

        get key() {
            return this.getAttribute(ATTR_ITEM_KEY);
        }

        parentLoading() {
            this.$parentItem?.classList.add(CN_LOADING);
        }
    }

    customElements.define('cart-qty-button', class extends CartControl {
        subscriptions = {
            'cart:error': '_onError',
            'cart:update': '_onUpdate'
        }
        
        render() {
            this.addEventListener('click', this._onQtyChange.bind(this), { once: true });
            this.subscribe('cart:error', { global: true });
            this.subscribe('cart:update', { global: true });
        };

        _onQtyChange(e) {
            e.preventDefault();
            this.parentLoading();
            document.querySelectorAll('cart-qty-button, cart-qty-input').forEach(el => {
                el.style.pointerEvents = 'none';
                el.querySelectorAll('svg > rect').forEach(rect => rect.style.fill = 'lightgrey');
                el.disabled = true;
            });
            this.publish('cart:change', {
                id: this.variantId,
                key: this.key,
                quantity: this.value,
                selling_plan: this.sellingPlanId,
                line: this.line,
                src: this.tagName
            })
        };
        
        _onError() {
            // Re-enable controls on error
            this._enableControls();
        }
        
        _onUpdate() {
            // Re-enable controls on successful update
            this._enableControls();
        }
        
        _enableControls() {
            document.querySelectorAll('cart-qty-button, cart-qty-input').forEach(el => {
                el.style.pointerEvents = '';
                el.querySelectorAll('svg > rect').forEach(rect => rect.style.fill = '');
                el.disabled = false;
            });
        }

        get value() {
            return this.getAttribute('set-value');
        }
    });

    customElements.define('cart-qty-input', class extends CartControl {
        subscriptions = {
            'cart:error': '_onError'
        }
        
        constructor() {
            super();
            this._isUpdating = false;
        }

        render() {
            this.addEventListener('change', this._onChange.bind(this));
            this.addEventListener('keydown', this._onKeyDown.bind(this));
            this.subscribe('cart:error', { global: true });
            
            // Store initial value
            const input = this.querySelector('input');
            if (input) {
                input.setAttribute('data-previous-value', input.value);
            }
        };

        _onKeyDown(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                e.target.blur();
            }
        }

        _onChange(e) {
            if (this._isUpdating) {
                return;
            }
            e.target.blur();
            this._updateQuantity(e);
        }

        _validateQuantity(value) {
            const input = this.querySelector('input[type="number"]');
            if (!input) return value;

            const numValue = parseInt(value, 10);
            if (isNaN(numValue) || numValue < 0) return input.min || 0;

            const maxValue = input.max ? parseInt(input.max, 10) : null;
            if (maxValue !== null && numValue > maxValue) {
                return maxValue;
            }

            return numValue;
        }

        _updateQuantity(e) {
            // Prevent double updates
            if (this._isUpdating) {
                return;
            }
            
            this._isUpdating = true;
            const input = e.target;
            const validatedValue = this._validateQuantity(input.value);
            input.value = validatedValue;
            
            // Update the stored previous value
            input.setAttribute('data-previous-value', validatedValue);

            this.parentLoading();
            this.publish('cart:change', {
                id: this.variantId,
                key: this.key,
                quantity: validatedValue,
                selling_plan: this.sellingPlanId,
                line: this.line,
                src: this.tagName
            });
            
            // Reset flag after a short delay
            setTimeout(() => {
                this._isUpdating = false;
            }, 100);
        }
        
        _onError() {
            // Reset the updating flag and restore previous value on error
            this._isUpdating = false;
            const input = this.querySelector('input');
            if (input) {
                const previousValue = input.getAttribute('data-previous-value');
                if (previousValue !== null) {
                    input.value = previousValue;
                }
            }
        }
    });
})();
